<template>
  <section class="group">
    <b-collapse :open="true" class="card has-background-white" style="border-radius: 8px;box-shadow: none">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">
          <span @click="active = !active" class="toggle-icon is-flex ml"
            style="border-right:0;padding-left: 6px;height: 25px;width: 25px;">
            <img v-if="active" class="fa-eye-btn" src="@/assets/eye.svg" />
            <img v-else class="fa-eye-btn" src="@/assets/eye-inactive.svg" />
          </span>
          <span class="group_name is-medium-16-500-19">{{ name }}</span>
        </p>
        <a class="card-header-icon">
          <svg viewBox="0 0 100 100" class="image is-24x24">
            <use v-if="!props.open" xlink:href="@/assets/sprite.svg#collapse" />
            <use v-else xlink:href="@/assets/sprite.svg#expand" />
          </svg>
        </a>
      </div>
      <div class="card-content">
        <vector :is_group_active="active" v-for="vector in group" :key="vector.class_id" :vector="vector"></vector>
      </div>
    </b-collapse>
  </section>
</template>
<script>
import vector from "./vector.component";
export default {
  props: ["group", "name"],
  components: {
    vector
  },
  data() {
    return {
      active: true
    };
  }
};
</script>
<style lang="scss" scoped>
.group {
  margin: 1rem 1.4rem;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
  border-radius: 10px;

  .card-header-title {
    font-family: Barlow-medium;
    font-size: 16px;
    color: #171e48;
    margin: 0;
    padding: 0;
    text-align: left;

    .toggle-icon {
      display: inline-block;
      height: 100%;
      border-right: 1px solid #d8dade;
      margin-right: 1rem;
      margin-left: 0.5rem;
    }

    .fa {
      height: 100%;
      margin-right: 1rem;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
    }

    .group_name {
      font-size: 15px;
      font-weight: 500;
      text-transform: capitalize;
      position: relative;
      justify-content: left;
      width: 130px;
      z-index: 1;

      @media (max-width: 900px) {
        width: 100px;
      }
    }

    .group-actions {
      display: flex;
      z-index: 10;
      right: 2.5rem;
      top: 10px;
      position: absolute;

      i {
        margin: 3px;
      }
    }
  }

  .active {
    color: #000;
    font-weight: 500;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.1rem 0.5rem 1rem 0.5rem;
  }

  .create-form {
    margin-bottom: 0.5rem;
    padding: 0 9px;

    .btn {
      border: 0;
    }

    .color-list {
      z-index: 100;
      background: white;
      position: absolute;
      width: 100%;
      height: 210px;
      left: 0;
      top: 2rem;
      bottom: 1rem;
      border: 1px solid #ccc;

      .fas {
        cursor: pointer;
        margin: 0.5rem;
      }
    }

    .buttons {
      margin-top: 0.5rem;

      .cancel-btn {
        border: none;
      }
    }

    .color-input {
      display: flex;
      align-items: center;
      border: 1px solid grey;

      .icon {
        margin: 0 8px;
      }

      .input {
        box-shadow: none;
        border: none;
      }
    }
  }
}
</style>
